var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-menu"},_vm._l((_vm.menuList),function(menu,i){return _c('router-link',{key:i,staticClass:"x-menu__item",attrs:{"tag":"div","to":menu.route}},[_c('img',{attrs:{"src":menu.icon,"alt":menu.name}}),_c('span',[_vm._v(_vm._s(menu.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }